const GIF_HEADER_87A = [0x47, 0x49, 0x46, 0x38, 0x37, 0x61];
const GIF_HEADER_89A = [0x47, 0x49, 0x46, 0x38, 0x39, 0x61];

export const GENIE_ICON_MAX_BYTES = 10 * 1024 * 1024;

export function isGifFile(file) {
  const contentType = String(file?.type || '').toLowerCase();
  const fileName = String(file?.name || '').toLowerCase();

  return contentType === 'image/gif' || fileName.endsWith('.gif');
}

function hasHeader(bytes, expectedHeader) {
  return expectedHeader.every((byte, index) => bytes[index] === byte);
}

export async function hasValidGifSignature(file) {
  if (!file || typeof file.slice !== 'function') return false;

  try {
    const header = new Uint8Array(await file.slice(0, 6).arrayBuffer());
    return header.length === 6 && (hasHeader(header, GIF_HEADER_87A) || hasHeader(header, GIF_HEADER_89A));
  } catch {
    return false;
  }
}

/**
 * Returns a user-facing validation error, or null when the file can be uploaded.
 * The existing contract allows all browser-recognised image types up to 10 MB.
 * GIFs additionally need a real GIF87a/GIF89a signature, since MIME types and
 * file extensions are both client-controlled.
 */
export async function validateGenieIconFile(file) {
  if (!file) return 'Please select an image file.';

  const contentType = String(file.type || '').toLowerCase();
  const isGif = isGifFile(file);
  const isImage = contentType.startsWith('image/') || isGif;

  if (!isImage) return 'Please select an image file.';
  if (file.size > GENIE_ICON_MAX_BYTES) return 'File size must not exceed 10MB.';
  if (isGif && !(await hasValidGifSignature(file))) return 'The selected GIF file is invalid.';

  return null;
}
